import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class MarkingProductCreateValidator {

    products_id = [
        Validators.required
    ];

    // Error messages
    errorMessages = {

        products_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ]
    }
}